/**
 * All possible states or events for a chat
 */
const ChatStates = {
    UIRendered: '_ui_rendered',
    Requested: '_requested',
    ChatRoomClicked: '_chatroom',
    Refreshed: '_refreshed',
    GreetingShown: '_greeting_shown',
    MessageSent: '_response_sent',
    MessageArrived: '_msg_rendered',
    BotMessagesStarted: '_auto_message_started',
    BotMessagesShown: '_auto_message_shown',
    SMSClicked: '_sms_requested',
    Started: '_started',
    InProgress: '_in_progress',
    Expired: '_expired',
    Ended: '_ended',
    PoppedOut: '_pop',
    PreloadedChatOptions: '_preloaded_chat_options'
};
export default ChatStates;
